// Panelist-facing interview UI strings — hand-curated EN + FR-CA.
// Add new keys here; keep both locales in sync.

const dict = {
  en: {
    // Loading / errors
    loading: "Loading…",
    error_generic: "Something went wrong.",
    over_quota: "This study is full. Thank you for your interest!",
    filled: "Survey has been filled",
    // Consent
    consent_title: "Quick voice interview",
    consent_body: "We'll ask a few quick questions out loud. Your voice is used only to transcribe your answers — never stored as a voice print.",
    consent_compliance: "Adrigo Insights AI is fully PIPEDA compliant. Your data is entirely anonymized.",
    consent_compliance_gdpr: "GDPR-compliant. You can request data deletion at any time. Data is processed in Canada with EU-equivalent safeguards.",
    consent_compliance_ccpa: "CCPA-compliant. You have the right to access or delete your data. Voice recordings are anonymized.",
    consent_compliance_hipaa: "HIPAA-aligned handling. No protected health information is requested or stored beyond what you choose to share.",
    consent_start: "Start interview",
    // Mic preflight
    mic_title: "Microphone check",
    mic_body: "We need access to your microphone for the voice portion. Click below to grant permission.",
    mic_grant: "Grant microphone access",
    mic_denied_title: "Microphone access denied",
    mic_denied_body: "No problem — you can type your answers instead.",
    mic_use_text: "Continue with text only",
    // Screener
    screener_title: "Quick screening",
    screener_body: "A few quick questions to make sure this study is a fit.",
    screener_submit: "Submit",
    screener_dq_title: "Thanks for your interest!",
    screener_dq_body: "Based on your responses, this particular study isn't a fit. We'll be in touch with future studies that match your profile.",
    // MC phase
    mc_progress: "Question {current} of {total}",
    mc_next: "Next",
    // Qual phase
    qual_hold_to_speak: "Hold to speak",
    qual_send: "Send",
    qual_text_placeholder: "Type your answer…",
    qual_retry_short: "Your answer lacks detail. Please elaborate to qualify for your reward.",
    qual_transcribing: "Transcribing…",
    qual_processing: "Processing…",
    // Thank you screens
    thanks_internal_title: "All done — thanks!",
    thanks_internal_reward: "Your {reward} reward is on the way",
    thanks_intercept_title: "Thank you from {company}.",
    thanks_pickfu_title: "Returning you to the panel…",
    review_title: "Submission under review",
    review_body: "We'll review your session and let you know.",
    terminated_title: "Session closed",
    terminated_body: "This session has been closed due to quality concerns.",
  },
  fr: {
    loading: "Chargement…",
    error_generic: "Une erreur s'est produite.",
    over_quota: "Cette étude est complète. Merci de votre intérêt !",
    filled: "L'enquête est complète",
    consent_title: "Court entretien vocal",
    consent_body: "Nous poserons quelques questions courtes à voix haute. Votre voix sert uniquement à transcrire vos réponses — jamais stockée comme empreinte vocale.",
    consent_compliance: "Adrigo Insights AI est entièrement conforme à la LPRPDE. Vos données sont entièrement anonymisées.",
    consent_compliance_gdpr: "Conforme au RGPD. Vous pouvez demander la suppression de vos données à tout moment.",
    consent_compliance_ccpa: "Conforme au CCPA. Vous avez le droit d'accéder à vos données ou de les supprimer.",
    consent_compliance_hipaa: "Traitement aligné HIPAA. Aucune information de santé protégée n'est demandée ni stockée.",
    consent_start: "Commencer l'entretien",
    mic_title: "Vérification du microphone",
    mic_body: "Nous avons besoin d'accéder à votre microphone pour la partie vocale. Cliquez ci-dessous pour autoriser.",
    mic_grant: "Autoriser le microphone",
    mic_denied_title: "Accès au microphone refusé",
    mic_denied_body: "Pas de souci — vous pouvez taper vos réponses à la place.",
    mic_use_text: "Continuer en mode texte",
    screener_title: "Présélection rapide",
    screener_body: "Quelques questions courtes pour vérifier que cette étude vous convient.",
    screener_submit: "Soumettre",
    screener_dq_title: "Merci de votre intérêt !",
    screener_dq_body: "D'après vos réponses, cette étude particulière ne vous convient pas. Nous vous contacterons pour de futures études qui correspondent à votre profil.",
    mc_progress: "Question {current} sur {total}",
    mc_next: "Suivant",
    qual_hold_to_speak: "Maintenez pour parler",
    qual_send: "Envoyer",
    qual_text_placeholder: "Tapez votre réponse…",
    qual_retry_short: "Votre réponse manque de détails. Merci d'élaborer pour être éligible à votre récompense.",
    qual_transcribing: "Transcription en cours…",
    qual_processing: "Traitement…",
    thanks_internal_title: "C'est terminé — merci !",
    thanks_internal_reward: "Votre récompense de {reward} est en route",
    thanks_intercept_title: "Merci de la part de {company}.",
    thanks_pickfu_title: "Retour vers le panel…",
    review_title: "Soumission en cours d'examen",
    review_body: "Nous examinerons votre session et vous tiendrons informé.",
    terminated_title: "Session fermée",
    terminated_body: "Cette session a été fermée en raison de préoccupations de qualité.",
  },
};

export function t(lang, key, vars = {}) {
  const locale = lang === "fr" ? "fr" : "en";
  const template = dict[locale][key] ?? dict.en[key] ?? key;
  return template.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "");
}

export function makeT(lang) {
  return (key, vars) => t(lang, key, vars);
}
